import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { NoAccessLayoutComponent } from '@core/layouts/no-access-layout/no-access-layout.component';
import { NoAccessGuard } from '@core/guards/no-access.guard';
import { CanLoadAppGuard } from '@core/guards/can-load-app.guard';

const routes: Routes = [
    {
        path: 'no-access',
        component: NoAccessLayoutComponent,
        canActivate: [NoAccessGuard],
    },
    {
        path: '',
        loadChildren: () =>
            import('@core/layouts/app-layout/app-layout.module').then(
                (m) => m.AppLayoutModule
            ),
        canLoad: [MsalGuard, CanLoadAppGuard],
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            initialNavigation:
                !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
                    ? 'enabledNonBlocking'
                    : 'disabled', // Set to enabledBlocking to use Angular Universal
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
